Vue.filter('noNewLine', function (value) {
    if (typeof value !== 'undefined' && value !== null) {
        value = value + '';
        return value.replace(/\r?\n|\r/g, ' ');
    }

    return null;
});
